import * as React from 'react';
import { grey } from '@mui/material/colors';
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import {
  Modal,
  Typography,
  InputAdornment,
  TextField,
  CircularProgress,
  Box,
  Backdrop,
  Fade,
  Button,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";

import BASE_URL from '../../config'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 4,
  p: 4,
  outline: 'none',
};

export default function TransitionsModal() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', color: '' });

  const handleOpen = () => {
    setOpen(true);
    setMessage({ text: '', color: '' });
    setEmail('');
  };
  
  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setMessage({ text: '', color: '' });

    try {
        const res = await fetch(`${BASE_URL}/auth/forgot-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });
        
        const data = await res.json();

        if (res.ok) {
            // Éxito: El usuario existe y el correo se envió
            setMessage({ text: 'Instrucciones enviadas. Revisa tu bandeja de entrada.', color: 'green' });
            // Cerramos después de 4 segundos para que lean el mensaje de éxito
            setTimeout(() => setOpen(false), 4000); 
        } else {
            // Error: El correo no existe (404) o error de servidor (500)
            setMessage({ 
                text: data.message || 'No pudimos encontrar tu cuenta.', 
                color: 'rgba(254, 0, 0, 0.65)' // Rojo de Material UI
            });
        }
    } catch (error) {
        setMessage({ text: 'Error de red. Intenta más tarde.', color: 'red' });
    } finally {
        setLoading(false);
    }
};

  return (
    <div>
      <Box>
        <Typography 
          onClick={handleOpen} 
          sx={{ cursor: 'pointer', ":hover": { color: grey[800] } }} 
          textAlign='end' 
          color='rgba(0, 0, 0, 0.4)'
        >
          ¿Olvidaste tu Contraseña?
        </Typography>
      </Box>

      <Modal
        aria-labelledby="modal-title"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: { timeout: 500 },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box sx={{display:'flex',flexDirection:'column',gap:2, minWidth: 280, maxWidth: 520,}}>
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  <Typography id="modal-title" variant="h6" >
                    Recuperar Contraseña
                  </Typography>
                  <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                </Box>

                <Typography sx={{ color: grey[600],textAlign:'start',mr:4 }}>
                  Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.
                </Typography>
              </Box>
              

              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 3 }}>
                  <Typography>
                    Correo Electrónico
                  </Typography>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        bgcolor: '#f5f5f5',
                        borderRadius: '8px',
                        '& fieldset': { borderColor: 'transparent' },
                        '&:hover fieldset': { borderColor: grey[400] },
                        '&.Mui-focused fieldset': { borderColor: grey[600] },
                      },
                    }}
                    fullWidth
                    required
                    type="email"
                    name='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="tu@ejemplo.com"
                    variant='outlined'
                    slotProps={{
                      input:{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MailOutlineOutlinedIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }
                    }}
                  />
                  {message.text && (
                    <Typography variant="caption" sx={{ color: message.color, mt: 1, display: 'block' }}>
                      {message.text}
                    </Typography>
                  )}
                </Box>

                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button
                    onClick={handleClose}
                    sx={{ borderRadius: '8px', textTransform: 'none', bgcolor:'white'}}
                    variant="contained"
                    color='secundary'
                    fullWidth
                  >
                    Cancelar
                  </Button>
                  <Button
                    sx={{ 
                      borderRadius: '8px', 
                      textTransform: 'none', 
                      bgcolor: 'black',
                      '&:hover': { bgcolor: grey[900] }
                    }}
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={loading || !email}
                  >
                    {loading ? <CircularProgress color="inherit" size={24} /> : 'Enviar'}
                  </Button>
                </Box>
              </form>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}